import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomOverlayMessaggeComponent } from './custom-overlay-messagge.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnimationComponent } from "../loading-animation/animation/animation.component";
import { CustomExpansionPanelModule } from "../custom-expansion-panel/custom-expansion-panel.module";
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    CustomOverlayMessaggeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AnimationComponent,
    CustomExpansionPanelModule,
    RouterModule
],
  exports: [
    CustomOverlayMessaggeComponent
  ]
})
export class CustomOverlayMessaggeModule { }
